export default __webpack_public_path__ + "static/media/vUst.40f3a0ae.svg";